export default {
    logout: 'Logout',
    msgConfirm: 'Make sure you want to Logout',
    cancel: 'Cancel',
    confirm: 'Confirm'
}
